import { useState } from 'react';

export default function ProductCatalog() {
  const handleQuoteClick = () => {
    const quotationSection = document.getElementById('quotation');
    if (quotationSection) {
      quotationSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="products" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-20">
          <h2 className="text-6xl font-bold">
            <span className="block text-gray-900">COMPLETE PALLET</span>
            <span className="block text-teal-600">INVENTORY</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-product-shop>
          <article className="lg:row-span-2 rounded-3xl overflow-hidden shadow-xl relative group">
            <div className="h-full min-h-[600px]">
              <img
                src="https://static.readdy.ai/image/0eec0f6b43802b90423f55e0902fba48/cedd127a9a80bac453661acf2ed9889a.png"
                alt="Standard Pallets - 48x40, 48x48, 40x48 sizes available"
                title="Buy Standard Pallets Nationwide"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-10 text-white">
                <h3 className="text-3xl font-bold mb-2">Standard Pallets</h3>
                <p className="text-xl">48×40 #1 or #2 Grade</p>
                <p className="mt-4 text-sm opacity-90">
                  <strong>Buy Standard Pallets Nationwide</strong> in multiple Grades for all your shipping needs
                </p>
              </div>
            </div>
          </article>

          <article className="rounded-3xl overflow-hidden shadow-xl relative group min-h-[290px]">
            <div className="h-full w-full">
              <img
                src="https://static.readdy.ai/image/0eec0f6b43802b90423f55e0902fba48/eccaca0b30d32993a7261601feff403c.png"
                alt="Custom Dimensions Pallets"
                title="Buy Custom Pallets Nationwide"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 p-10 flex flex-col justify-between">
                <div className="flex-1 flex flex-col justify-center items-center text-center text-white">
                  <h3 className="text-2xl font-bold mb-3">
                    Custom Dimensions Available
                  </h3>
                  <p className="text-white/90">
                    <strong>Buy Custom Pallets Nationwide</strong> tailored to your exact specifications
                  </p>
                </div>
                <div className="text-right">
                  <span 
                    onClick={handleQuoteClick}
                    className="text-white font-semibold hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Request Quote →
                  </span>
                </div>
              </div>
            </div>
          </article>

          <article className="rounded-3xl overflow-hidden shadow-xl relative group min-h-[290px]">
            <div className="h-full w-full">
              <img
                src="https://static.readdy.ai/image/0eec0f6b43802b90423f55e0902fba48/e3a3afdddc3662c21f15d2b839c7344d.png"
                alt="GMA Certified Pallets"
                title="Buy GMA Pallets Nationwide"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 p-10 flex flex-col justify-between">
                <div className="flex-1 flex flex-col justify-center items-center text-center text-white">
                  <h3 className="text-2xl font-bold mb-3">
                    GMA Certified Options
                  </h3>
                  <p className="text-white/90">
                    <strong>Buy GMA Certified Pallets Nationwide</strong> meeting food-grade compliance standards
                  </p>
                </div>
                <div className="text-right">
                  <span 
                    onClick={handleQuoteClick}
                    className="text-white font-semibold hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    View Specs →
                  </span>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}